// src/pages/LandingPage.jsx
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom'; 
import AOS from 'aos';
import 'aos/dist/aos.css';

const BRAND_ORANGE = '#F89423';
const BRAND_ORANGE_DARK = '#ea7c1f';

const LandingPage = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  // ✅ Added unique 'path' for each service
  const services = [
    { icon: 'fas fa-briefcase', title: 'Outsourcing', path: '/outsourcing', delay: 100 },
    { icon: 'fas fa-heartbeat', title: 'HMO Services', path: '/hmoadmin', delay: 200 },
    { icon: 'fas fa-user-plus', title: 'Recruitment', path: '/recruitment', delay: 300 },
    { icon: 'fas fa-shipping-fast', title: 'Dispatch Services', path: '/dispatch', delay: 400 },
    { icon: 'fas fa-car', title: 'Rent a Driver', path: '/rent-a-driver', delay: 500 },
    { icon: 'fas fa-users-cog', title: 'HR Management', path: '/hr-management', delay: 600 }
  ];

  return (
    <div style={styles.container}>
      {/* Header with Logo */}
      <header style={styles.header}>
        <div style={styles.headerContainer}>
          <div style={styles.logoSection}>
            <div style={styles.logoText}>
               <img 
            src="/images/fsl_logo.png" 
            alt="FSL Logo" 
            style={{ height: '50px', marginBottom: '12px' }}
            onError={(e) => { e.target.style.display = 'none'; }}
          />
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div style={styles.mainContainer}>
        {/* Services Grid */}
        <div style={styles.servicesGrid}>
          {services.map((service, index) => (
            // ✅ The ENTIRE card is now the Link
            <Link 
              to={service.path}
              key={index} 
              className="service-card-hover"
              style={styles.serviceCard} 
              data-aos="fade-up" 
              data-aos-delay={service.delay}
            >
              <div style={styles.iconWrapper}>
                <i className={service.icon} style={styles.serviceIcon}></i>
              </div>
              <h3 style={styles.serviceTitle}>{service.title}</h3>
              
              {/* ✅ "Access Portal" button completely removed */}
            </Link>
          ))}
        </div>
      </div>

      {/* Added a style tag for the hover effect since inline styles don't support :hover */}
      <style>{`
        .service-card-hover {
          transition: all 0.3s ease;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center; /* ✅ Centers content vertically since button is gone */
          min-height: 250px; /* ✅ Gives the card a nice, consistent height */
        }
        .service-card-hover:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.15) !important;
        }
        .service-card-hover:hover .icon-wrapper {
          transform: scale(1.05);
        }
      `}</style>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  },
  header: {
    background: `linear-gradient(135deg, white 0%, ${BRAND_ORANGE_DARK} 100%)`,
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    borderBottom: `3px solid ${BRAND_ORANGE_DARK}`
  },
  headerContainer: {
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '1rem 2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '2rem'
  },
  logoSection: { display: 'flex', alignItems: 'center', gap: '1rem' },
  logoText: { display: 'flex', flexDirection: 'column' },
  headerActions: { display: 'flex', gap: '1rem', alignItems: 'center' },
  getStartedBtn: {
    padding: '0.6rem 1.5rem', background: 'white', color: BRAND_ORANGE, border: 'none',
    borderRadius: '25px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.3s ease',
    fontSize: '0.9rem', boxShadow: '0 4px 10px rgba(0,0,0,0.1)', textDecoration: 'none', 
    display: 'inline-flex', alignItems: 'center'
  },
  mainContainer: { maxWidth: '1400px', margin: '0 auto', padding: '4rem 2rem' },
  servicesGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '2.5rem', marginBottom: '4rem'
  },
  serviceCard: {
    background: 'white', 
    borderRadius: '20px', 
    padding: '2.5rem', 
    textAlign: 'center',
    boxShadow: '0 10px 30px rgba(0,0,0,0.1)', 
    cursor: 'pointer', 
    position: 'relative', 
    overflow: 'hidden',
    // ✅ Added to prevent default browser link styling (removes underline and blue text)
    textDecoration: 'none',
    color: 'inherit'
  },
  iconWrapper: {
    width: '100px', height: '100px', margin: '0 auto 1.5rem',
    background: `linear-gradient(135deg, ${BRAND_ORANGE} 0%, ${BRAND_ORANGE_DARK} 100%)`,
    borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
    boxShadow: `0 8px 20px rgba(248, 148, 35, 0.4)`, transition: 'transform 0.3s ease'
  },
  serviceIcon: { fontSize: '2.5rem', color: 'white' },
  serviceTitle: { fontSize: '1.5rem', color: '#333', marginBottom: '0', fontWeight: '600' }
};

export default LandingPage;